import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function LoadingSkeleton(props) {
  return (
    <SkeletonTheme baseColor="#2b2b2b" highlightColor="#444">
      <Skeleton {...props} />
    </SkeletonTheme>
  );
}

export default LoadingSkeleton;
